import { z } from 'zod'
import validator from '~/utils/shared/validateCpf'

type MaskOptions = {
  pattern: RegExp
  clean: (value: string) => string
  minLength?: number
  maxLength?: number
}

// Função base para validar campos com máscara
const createMaskValidator = (options: MaskOptions, customError?: string) => {
  return z
    .string()
    .refine(value => {
      const cleaned = options.clean(value)
      if (options.minLength && cleaned.length < options.minLength) return false
      if (options.maxLength && cleaned.length > options.maxLength) return false
      return options.pattern.test(value)
    }, customError || 'Formato inválido')
    .transform(options.clean)
}

export const cpf = () => {
  const cleanCpf = (cpf: string) => cpf.replace(/\D/g, '')

  const cpfMaskOptions: MaskOptions = {
    pattern: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/,
    clean: cleanCpf,
    minLength: 11,
    maxLength: 11,
  }

  return createMaskValidator(cpfMaskOptions, 'CPF no formato inválido').refine(
    validator,
    'CPF inválido',
  )
}
